<div class="flex align-items-center justify-content-center w-full font-bold border-round m-2 text-3xl title-case">
    Resend UCM
</div>
<p-card>
    <div class="wrapper">
        <form [formGroup]="resendUCMForm" (ngSubmit)="onSubmit(resendUCMForm)">
            <div class="form-control">
                <label for="pacsControl" class="required-field">
                    Enter or paste PACs :
                </label>
                <textarea 
                    id="pacsControl"
                    pInputTextarea 
                    formControlName="pacsControl" 
                    placeholder="Enter one or multiple PACs separated by comma (,)">
                </textarea>
                <div [ngClass]="{'visible': resendUCMForm.invalid}" class="form-control-messsage error-msg">
                    <span *ngIf="resendUCMForm.controls['pacsControl'].errors?.['invalidPac']">
                       PAC should be alpha numeric and should be 12-13 characters.
                    </span>
                    <span *ngIf="resendUCMForm.controls['pacsControl'].errors?.['maxPacNumbers']">
                        Exceeded allowed numbers of PACs (10).
                    </span>
                </div>
                <div *ngIf="!resendUCMForm.controls['pacsControl'].valid && resendUCMForm.controls['pacsControl'].dirty"
                class="error-msg">
                <span *ngIf="resendUCMForm.controls['pacsControl']?.hasError('required')">
                    PAC is required</span>
                </div>
            </div>
            <div class="form-buttons">
                <button 
                    [disabled]="resendUCMForm.invalid"
                    pButton     
                    type="submit" 
                    label="Send"
                    icon="pi pi-send"></button>
            </div>
        </form>
        <!-- <div class="result-wrapper">
            <div *ngFor="let result of pacsResult | keyvalue">
                <span class="result-label">
                    Resend {{result.key}}:
                    <span class="response-status">
                        <i *ngIf="result.value === null" class="pi pi-spin pi-spinner"></i>
                        <i *ngIf="result.value !== null && result.value?.successful" class="pi pi-check-circle success"></i>
                        <i *ngIf="result.value !== null && !result.value?.successful" class="pi pi-times error"></i>
                    </span>
                </span>
                <span 
                    *ngIf="result.value !== null" 
                    class="response-result">
                    <span>Response code: {{result.value?.responseCode}}</span>
                    <span>Response message: {{result.value?.message}}</span>
                </span>
            </div>
        </div> -->
    </div>
    <p-toast styleClass="custom-toast" life="10000" position="top-center"></p-toast>
    <div class="flex flex-wrap">
        <div class="flex align-items-center justify-content-center m-2"><i class="pi pi-exclamation-triangle" style="color: orange;"></i></div>
        <div class="flex align-items-center justify-content-center m-1 menu-item-text">Multiple PACs must be entered comma delimited with no spaces</div>
    </div>
</p-card>
